import { Component } from 'vue-property-decorator'
import { WorkoutExercise } from '@src/data/workout-exercise'
import Vue from '@src/vue'
import { CreateElement } from 'vue'
import ExerciseSelector from '@src/components/exercise-selector/exercise-selector'

@Component({
  computed: {
    selectedExercises () {
      return this.$store.state.new_workout.workoutExercises
    }
  }
})
export class WorkoutExerciseSelector extends Vue {

  protected selectedExercises: WorkoutExercise[]

  render (h: CreateElement) {
    return <ExerciseSelector expandableFilters={true} selectedExercises={this.selectedExercises} />
  }
}
